import { Box, Typography, SxProps, Theme } from '@mui/material';
import React from 'react';

interface TransactionFieldProps {
  label: string;
  value: React.ReactNode;
  description?: React.ReactNode;
  large?: boolean;
  align?: 'flex-start' | 'flex-end' | 'center';
  invertColor?: boolean;
  sx?: SxProps<Theme>;
}

const TransactionField = ({
  label,
  value,
  description,
  large,
  align = 'flex-start',
  invertColor = false,
  sx,
}: TransactionFieldProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: align,
      ...(align === 'flex-end' ? { ml: 1 } : { mr: 1 }),
      ...sx,
    }}
  >
    <Typography
      variant="subtitle2"
      color={invertColor ? 'common.white' : 'text.secondary'}
      gutterBottom
      align={align === 'flex-end' ? 'right' : 'left'}
      sx={{ fontWeight: 'bold' }}
    >
      {label}
    </Typography>
    <Typography
      variant={large ? 'h4' : 'body1'}
      align={align === 'flex-end' ? 'right' : 'left'}
      color={invertColor ? 'common.white' : 'text.primary'}
    >
      {value}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        color={invertColor ? 'common.white' : 'text.secondary'}
        align={align === 'flex-end' ? 'right' : 'left'}
      >
        {description}
      </Typography>
    )}
  </Box>
);

export default TransactionField;
